export const APPROVAL_FOOTER =
  process.env.REACT_APP_APPROVAL_FOOTER ||
  'Códigos de aprobación: BMS: ONC-LR-2600057; Junio 2026'

export const CONSENT_CODE =
  process.env.REACT_APP_CONSENT_CODE || 'Código ONC-LA-240003'

export const COUNTRIES_ENROLLMENT_URL = `${process.env.REACT_APP_BMS_PSP_ENDPOINT}/psplatam/countries/active?context=enrollment`
